import React from 'react';
import { MapPin, Clock, Video, Calendar as CalendarIcon, ArrowRight } from 'lucide-react';
export function EventsCalendar() {
  const events = [{
    titleEs: 'Reunión de la Mesa Directiva',
    titleEn: 'Board Meeting',
    date: '12',
    month: 'JUN',
    fullDateEs: '12 de Junio, 2026',
    fullDateEn: 'June 12, 2026',
    time: '6:30 PM',
    location: 'Sylmar Recreation Center',
    isVirtual: true
  }, {
    titleEs: 'Comité de Uso de Suelo',
    titleEn: 'Land Use Committee',
    date: '05',
    month: 'JUN',
    fullDateEs: '5 de Junio, 2026',
    fullDateEn: 'June 5, 2026',
    time: '7:00 PM',
    location: 'Virtual vía Zoom',
    isVirtual: true
  }, {
    titleEs: 'Comité de Educación',
    titleEn: 'Education Committee',
    date: '08',
    month: 'JUN',
    fullDateEs: '8 de Junio, 2026',
    fullDateEn: 'June 8, 2026',
    time: '6:00 PM',
    location: 'Sylmar Library',
    isVirtual: false
  }, {
    titleEs: 'Comité de Seguridad Pública',
    titleEn: 'Public Safety Committee',
    date: '10',
    month: 'JUN',
    fullDateEs: '10 de Junio, 2026',
    fullDateEn: 'June 10, 2026',
    time: '7:00 PM',
    location: 'Virtual vía Zoom',
    isVirtual: true
  }];
  return <section className="py-24 px-6 lg:px-8 bg-white" data-id="element-24">
      <div className="max-w-5xl mx-auto" data-id="element-25">
        <div className="text-center mb-16" data-id="element-26">
          <h2 className="text-3xl md:text-4xl font-bold text-charcoal mb-2 notranslate" data-id="element-27">
            Calendario de Eventos
          </h2>
          <p className="text-xl text-sylmar font-medium notranslate" data-id="element-28">
            Events Calendar
          </p>
          <div className="w-24 h-1 bg-warm mx-auto rounded-full mt-6" data-id="element-29"></div>
        </div>

        <div className="flex flex-col gap-4" data-id="element-30">
          {events.map((event, index) => <div key={index} className="group flex flex-col md:flex-row gap-6 bg-white p-6 rounded-xl shadow-sm border border-gray-100 border-l-4 border-l-sylmar hover:shadow-md transition-all" data-id="element-31">
              {/* Date Badge */}
              <div className="flex-shrink-0 flex flex-col items-center justify-center bg-sylmar-light text-sylmar rounded-lg w-20 h-20 border border-sylmar/20 group-hover:bg-sylmar group-hover:text-white transition-colors" data-id="element-32">
                <span className="text-sm font-bold uppercase tracking-wider" data-id="element-33">
                  {event.month}
                </span>
                <span className="text-3xl font-black leading-none mt-1" data-id="element-34">
                  {event.date}
                </span>
              </div>

              {/* Event Details */}
              <div className="flex-grow flex flex-col justify-center" data-id="element-35">
                <div className="flex flex-wrap items-center gap-3 mb-2" data-id="element-36">
                  <div data-id="element-37">
                    <h3 className="text-xl font-bold text-charcoal group-hover:text-sky transition-colors leading-tight" data-id="element-38">
                      {event.titleEs}
                    </h3>
                    <p className="text-sm text-sky-dark font-medium" data-id="element-39">
                      {event.titleEn}
                    </p>
                  </div>
                  {event.isVirtual && <span className="bg-sky/10 text-sky-dark text-xs font-bold px-2.5 py-1 rounded-full flex items-center gap-1 h-fit" data-id="element-40">
                      <Video className="w-3 h-3" data-id="element-41" /> Opción Virtual / Virtual
                      Option
                    </span>}
                </div>

                <div className="flex flex-wrap gap-x-6 gap-y-2 text-sm text-gray-600 mt-2" data-id="element-42">
                  <div className="flex items-center gap-1.5" data-id="element-43">
                    <CalendarIcon className="w-4 h-4 text-sylmar" data-id="element-44" />
                    <span data-id="element-45">
                      {event.fullDateEs}{' '}
                      <span className="text-gray-400 italic" data-id="element-46">
                        ({event.fullDateEn})
                      </span>
                    </span>
                  </div>
                  <div className="flex items-center gap-1.5" data-id="element-47">
                    <Clock className="w-4 h-4 text-sylmar" data-id="element-48" />
                    {event.time}
                  </div>
                  <div className="flex items-center gap-1.5 notranslate" data-id="element-49">
                    <MapPin className="w-4 h-4 text-sylmar" data-id="element-50" />
                    {event.location}
                  </div>
                </div>
              </div>

              {/* Action */}
              <div className="flex items-center md:justify-end mt-4 md:mt-0" data-id="element-51">
                <button className="text-charcoal bg-gray-50 hover:bg-warm hover:text-charcoal px-4 py-2 rounded-lg font-semibold text-sm transition-colors border border-gray-200 hover:border-warm flex flex-col items-center" data-id="element-52">
                  <span data-id="element-53">Detalles</span>
                  <span className="text-xs font-normal text-gray-500" data-id="element-54">
                    Details
                  </span>
                </button>
              </div>
            </div>)}
        </div>

        <div className="mt-12 text-center" data-id="element-55">
          <button className="inline-flex flex-col items-center justify-center gap-1 bg-charcoal hover:bg-charcoal-light text-white px-8 py-3 rounded-lg transition-colors shadow-lg" data-id="element-56">
            <div className="flex items-center gap-2 font-semibold" data-id="element-57">
              <CalendarIcon className="w-5 h-5" data-id="element-58" />
              Ver calendario completo
            </div>
            <span className="text-xs text-gray-300" data-id="element-59">View full calendar</span>
          </button>
        </div>
      </div>
    </section>;
}